import React from "react";
import "./DepartmentList.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";

const DepartmentListComponent = (props) => {
  const {
    loading,
    error,
    departmentList,
    corporateName,
    handleBackClick,
    handleDepartmentClick,
    retryFetch,
    searchValue,
    handleSearchInputChange,
    handleSearch,
  } = props;

  /* ============================
      SEARCH FILTER
  ============================ */

  const filteredDepartments =
    departmentList?.departments?.filter((dept) => {
      if (!searchValue) return true;

      const search = searchValue.toLowerCase();

      return (
        dept.departmentId?.toString().toLowerCase().includes(search) ||
        dept.id?.toString().toLowerCase().includes(search) ||
        dept.departmentName?.toLowerCase().includes(search) ||
        dept.name?.toLowerCase().includes(search)
      );
    }) || [];

  /* ============================
      LOADING
  ============================ */

  if (loading) {
    return (
      <div className="department-list-container">
        <div className="sidebar-container">
          <Sidebar />
        </div>

        <div className="department-content">
          <div className="department-top-nav">
            <div className="department-nav-left">
              <button className="back-button-nav" onClick={handleBackClick}>
                ←
              </button>
              <h2 className="nav-title">Departments</h2>
            </div>
          </div>

          <div className="deprt-loading-state">
            <div className="deprt-loading-spinner"></div>
            <p className="deprt-loading-text">Loading departments...</p>
          </div>
        </div>
      </div>
    );
  }

  /* ============================
      ERROR
  ============================ */

  if (error) {
    return (
      <div className="department-list-container">
        <div className="sidebar-container">
          <Sidebar />
        </div>

        <div className="department-content">
          <div className="department-top-nav">
            <div className="department-nav-left">
              <button className="back-button-nav" onClick={handleBackClick}>
                ←
              </button>
              <h2 className="nav-title">Departments</h2>
            </div>
          </div>

          <div className="error-state">
            <div className="error-icon">⚠️</div>
            <h3 className="error-title">Error Loading Data</h3>
            <p className="error-description">{error}</p>
            <button className="retry-button" onClick={retryFetch}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  /* ============================
      MAIN UI
  ============================ */

  return (
    <div className="department-list-container">
      <div className="sidebar-container">
        <Sidebar />
      </div>

      <div className="department-content">

        {/* TOP BAR */}
        <div className="department-top-nav">
          <div className="department-nav-left">
            <button className="back-button-nav" onClick={handleBackClick}>
              ←
            </button>
            <h2 className="nav-title">Departments</h2>
            <span className="corporate-name-nav">{corporateName}</span>
          </div>

          {/* SEARCH */}
          <div className="deprtment-deprtment-search-section">
            <div className="department-search-container">
              <input
                type="text"
                placeholder="Search by  ID or Name"
                value={searchValue}
                onChange={handleSearchInputChange}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                className="search-input"
              />
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="department-main-content">
          <div className="table-container">

            {filteredDepartments.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon">🏢</div>
                <h3 className="empty-state-title">
                  {searchValue ? "No Departments Found" : "No Departments"}
                </h3>
                <p className="empty-state-description">
                  {searchValue
                    ? `No departments match "${searchValue}"`
                    : "No departments available."}
                </p>
              </div>
            ) : (
              <table className="department-table">
                <thead>
                  <tr>
                    <th>Department ID</th>
                    <th>Department Name</th>
                    <th>Total Employees</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredDepartments.map((dept) => (
                    <tr
                      key={dept.id}
                      onClick={() =>
                        handleDepartmentClick &&
                        handleDepartmentClick(
                          dept.departmentId || dept.id,
                          dept
                        )
                      }
                      style={{
                        cursor: handleDepartmentClick
                          ? "pointer"
                          : "default",
                      }}
                    >
                      <td>
                        <span className="dept-id-cell">
                          {dept.departmentId || dept.id}
                        </span>
                      </td>

                      <td className="dept-name-cell">
                        {dept.departmentName || dept.name}
                      </td>

                      <td>
                        <div className="employees-count-cell">
                          <span className="count-badge">
                            {dept.totalEmployees || "0"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentListComponent;
